import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  ResourceDto,
  SequenceDto,
  SkillStaticDataDto,
  LearningObjectDataDto,
  LearningObjectLessonAndModuleDto,
  ResourceInfoDto,
  EolsCollectionDto,
  LessonInfoDto, LessonQuestionDto
} from './ocs-api-service.dtos';

export const fetchLessonTopics = (lessonId: string): Promise<string[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/lesson/vtw/${lessonId}/topics`);
  });
};

export const fetchSequence = (vtwId: string): Promise<SequenceDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/sequence/data/resource/${vtwId}`);
  });
};

export const fetchEvolveResource = (vtwId: string): Promise<ResourceDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/collectionObject/vtw/${vtwId}`);
  });
};

export const fetchEvolveResourcesData = (vtwIds: string[]): Promise<Record<string, string>> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post('/collectionObject/vtwIds/data', { data: vtwIds });
  });
};

export const fetchSkillStaticData = (skillVersionVtwId: string): Promise<SkillStaticDataDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/skill/vtw/${skillVersionVtwId}`);
  });
};

export const fetchLearningObjectData = (vtwId: string): Promise<LearningObjectDataDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/learningObject/vtw/${vtwId}/data`);
  });
};

export const fetchLearningObjectLessonAndModule = (vtwId: string): Promise<LearningObjectLessonAndModuleDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/learningObject/vtw/${vtwId}/lessonAndModule`);
  });
};

export const fetchResourceInfo = (vtwId: string): Promise<ResourceInfoDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/resourceInfo/vtw/${vtwId}`);
  });
};

export const fetchInteractiveReviewQuiz = (vtwId: string): Promise<ResourceDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/conceptResource/vtw/${vtwId}`);
  });
};

export const fetchInteractiveReviewQuizQuestions = (vtwId: string): Promise<EolsCollectionDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/learningObject/vtw/${vtwId}`);
  });
};

export const fetchSLSQuizQuestions = (vtwId: string): Promise<EolsCollectionDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/learningObject/eolsCollection/${vtwId}`);
  });
};

export const fetchKnowledgeCardLessonInfo = (assignmentId = 0, vtwId: string, isbn: number): Promise<LessonInfoDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/knowledgecard/lesson/info?assignmentId=${assignmentId}&lessonVtwId=${vtwId}&isbn=${isbn}`);
  });
};

export const fetchKnowledgeCardLessonQuestions = (topicVtwId, assignmentType: string, isbn: number): Promise<LessonQuestionDto[]> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/knowledgecard/lesson/questions?topicIds=${topicVtwId}&assignmentType=${assignmentType}&isbn=${isbn}`);
  });
};
